import { useLanguageStore } from '@/shared/i18n'
import { viewerApi } from '../api/viewer-api'
import type { Viewer } from './types'
import { useViewerStore } from './viewer-store'

let isPushing = false

/**
 * Сведение языка интерфейса с профилем.
 *
 * - На бэкенде язык выбран вручную — он и применяется, в том числе поверх
 *   локального выбора: серверный — последний сделанный с любого устройства,
 *   и его же получают уведомления бота.
 * - На бэкенде не выбран, а локально выбран (выбор сделан, но не дошёл) —
 *   локальный отправляется на бэкенд, иначе бот пишет не на том языке.
 * - Не выбран нигде — язык из профиля только подсказка, как язык Telegram.
 */
export const syncViewerLanguage = (viewer: Viewer): void => {
  const { language, isExplicit, setLanguage, suggestLanguage } = useLanguageStore.getState()

  if (viewer.languageIsExplicit) {
    if (!isExplicit || language !== viewer.language) {
      setLanguage(viewer.language)
    }

    return
  }

  if (!isExplicit) {
    suggestLanguage(viewer.language)

    return
  }

  if (isPushing) {
    return
  }

  isPushing = true
  viewerApi
    .chooseLanguage(language)
    .then((updated) => useViewerStore.getState().setViewer(updated))
    // Не критично: попробуем при следующем чтении профиля.
    .catch((error: unknown) => console.warn('[viewer] язык не сохранён в профиле', error))
    .finally(() => {
      isPushing = false
    })
}
